import { AutoMap } from '@automapper/classes';

export class MaterielAdductionEntity {
    Id?: number;
    @AutoMap()
    Type!: number;
    @AutoMap()
    Fabricant!: string;
    @AutoMap()
    Description!: string;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    ReferenceHuile!: string;
    // MaterielCompresseurId?: number;
}
